import api from 'services/api';
import { PortfolioV2Api, RedeemRewardsResponseDto, ReferralHistoryDto, RewardActionSummaryDto, RewardsApi, RewardsDetailsQueryResponse, RewardTierDto } from 'services/generated';
import { handleErrors } from 'services/helpers';
import { rootApi } from 'store/root-api';

const rewardsClient = new RewardsApi(undefined, undefined, api);
const portfolioClient = new PortfolioV2Api(undefined, undefined, api);

export interface PaginationArgs {
    skip?: number;
    take?: number;
    orderBy?: string;
    orderByDescending?: string;
}

export const rewardsApi = rootApi.injectEndpoints({
    endpoints: builder => ({
        getRewardTiers: builder.query<RewardTierDto[], void>({
            queryFn: () => handleErrors(() => rewardsClient.getRewardTiersV2()),
        }),
        getRewardDetails: builder.query<RewardsDetailsQueryResponse, void>({
            queryFn: () => handleErrors(() => rewardsClient.getRewardDetailsV2()),
            providesTags: [{ type: 'Rewards' }],
        }),
        getRewardActions: builder.query<RewardActionSummaryDto[], void>({
            queryFn: () => handleErrors(() => rewardsClient.getRewardActions()),
            providesTags: [{ type: 'Rewards' }],
        }),
        redeemRewards: builder.mutation<RedeemRewardsResponseDto, void>({
            queryFn: (request) => handleErrors(() => rewardsClient.redeem()),
            invalidatesTags: [{ type: 'Rewards' }],
        }),
        getReferralHistory: builder.query<ReferralHistoryDto[], void>({
            queryFn: () => handleErrors(() => rewardsClient.getReferralHistoryV2()),
        }),
    }),
});

export const { useGetRewardTiersQuery, useGetRewardDetailsQuery, useGetRewardActionsQuery, useRedeemRewardsMutation, useGetReferralHistoryQuery } = rewardsApi;